export default "__VITE_ASSET__B3jIisQ5__"